<div class="heatmap" style="max-height: 320px;">
  @if (ready) {
    <ngx-charts-line-chart #chart1 class="dark"
      [scheme]="colorScheme"
      [results]="chartData"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [legend]="legend"
      [curve]="curve"
      [yScaleMin]="min"
      [yScaleMax]="max"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [animations]="animations"
      [showGridLines]="showGridLines"
      [roundDomains]="roundDomains">
    </ngx-charts-line-chart>
  }
  @if (!ready) {
    <div class="d-flex justify-content-center align-items-center" style="height: 280px;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
</div>